<div class="tw-bg-white tw-rounded-lg tw-shadow-tb tw-w-full tw-flex tw-flex-col" [ngClass]="{ 'tw-h-full': filteredHotels().length > 4 && !isIndividualView(), 'tw-pt-3': !isIndividualView() }">
    @if (!loadingRecommendations) {
        @if (isIndividualView()) {
            <div class="tw-flex tw-items-center tw-gap-1 tw-border-b tw-border-gray-100 tw-px-4 tw-py-4 tw-text-base tw-font-semibold tw-text-gray-500">
                <img src="https://statics.myhotel.cl/uitls/smart-reply-icon-01.svg">
                <span>{{ 'interchain-dashboard.recommendation' | translate }}</span>
                <i
                    class="far fa-info-circle"
                    [mhTooltip]="'interchain-dashboard.recommendation_tooltip' | translate: { past_month: 'datepicker.months.' + pastMonth | translate, past_year: pastYear }"
                ></i>
                <span class="tw-text-main-blue tw-italic tw-ml-1">({{ 'interchain-dashboard.beta_text' | translate }})</span>
            </div>

            @if (individualRecommendation()) {
                <div class="tw-flex tw-flex-col tw-gap-4 tw-p-4 md:tw-flex-row md:tw-items-center md:tw-justify-between">
                    <p class="tw-m-0 tw-text-base tw-font-medium tw-leading-6 tw-text-main-text md:tw-max-w-[75%]">
                        {{ individualRecommendation().recommendation || 'interchain-dashboard.no_recommendation_available' | translate }}
                    </p>
                    <mh-core-lib-button
                        [text]="isMobile ? ('commons.see' | translate) : ('commons.see_more' | translate)"
                        [isSecondary]="true"
                        [width]="'tw-w-fit'"
                        [height]="34"
                        [customClass]="'!tw-shadow-none'"
                        [textClass]="'tw-font-normal'"
                        [isDisabled]="!individualRecommendation().available"
                        [mhTooltip]="individualRecommendation().available ? '' : 'interchain-dashboard.no_recommentaion_tooltip' | translate"
                        [isDownloading]="generatingPdf() && selectedHotel() === individualRecommendation()"
                        [loaderClass]="'tw-flex tw-items-center tw-justify-center tw-w-[48px]'"
                        (clicked)="handlePdfReport(individualRecommendation())">
                    </mh-core-lib-button>
                </div>
            } @else {
                <p class="tw-text-center tw-text-gray-400 tw-text-base tw-italic tw-p-4">
                    {{ 'interchain-dashboard.widget_no_data' | translate }}
                </p>
            }
        } @else {
            <!-- Search input -->
            <div class="tw-px-4 tw-mb-3 tw-flex-shrink-0">
                <div class="tw-relative tw-w-[22%]" [ngClass]="{'tw-w-full': isMobile}">
                    <i class="fas fa-search tw-absolute tw-left-3 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-text-gray-400"></i>
                    <input
                        type="text"
                        [placeholder]="'interchain-dashboard.search_hotel' | translate"
                        [(ngModel)]="searchTerm"
                        (input)="filterHotels()"
                        class="tw-w-full tw-pl-10 tw-px-4 tw-py-2 tw-border tw-border-gray-300 tw-rounded-lg focus:tw-outline-none focus:tw-ring-main-blue focus:tw-border-main-blue"
                    >
                </div>
            </div>
            <div class="tw-overflow-x-auto tw-rounded-lg tw-flex tw-flex-col" [ngClass]="{ 'tw-flex-1': filteredHotels.length > 4 }">
                <!-- Tabla de encabezados fija -->
                <table class="tw-w-full tw-flex-shrink-0">
                    <thead>
                        <tr>
                            <th class="tw-py-4 tw-pl-4 tw-w-1/4 tw-text-gray-500 tw-text-base tw-font-medium">
                                <span>{{ 'commons.hotel' | translate }}</span>
                            </th>
                            <th class="tw-py-4 tw-w-3/4 tw-text-gray-500 tw-text-base tw-font-medium">
                                <div class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-w-fit" [mhTooltip]="'interchain-dashboard.recommendation_tooltip' | translate: { past_month: 'datepicker.months.' + pastMonth | translate, past_year: pastYear }">
                                    <img src="https://statics.myhotel.cl/uitls/smart-reply-icon-01.svg">
                                    <span>{{ 'interchain-dashboard.recommendation' | translate }} <i class="far fa-info-circle"></i></span>
                                    <span class="tw-text-main-blue tw-italic tw-ml-1">({{ 'interchain-dashboard.beta_text' | translate }})</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                </table>

                <!-- Contenido de la tabla con scroll -->
                <div class="tw-overflow-y-auto" [ngClass]="{ 'tw-flex-1': filteredHotels().length > 4, 'tw-max-h-[22rem]': filteredHotels().length <= 4 }">
                    <table class="tw-w-full">
                        <tbody>
                            @if (filteredHotels().length > 0) {
                                @for (hotel of filteredHotels(); track hotel.customer_name; let last = $last, even = $even) {
                                    <tr [class.tw-border-b]="!last" [class.tw-bg-gray-50]="even" class="tw-border-gray-100">
                                        <td class="tw-py-4 tw-pl-4 tw-w-1/4">
                                            <p class="tw-max-w-[10rem] md:tw-text-base tw-text-sm">{{ hotel.customer_name }}</p>
                                        </td>
                                        <td class="tw-py-4 tw-w-2/4">
                                            <p class="md:tw-text-base tw-text-sm">{{ hotel.recommendation || 'interchain-dashboard.no_recommendation_available' | translate }}</p>
                                        </td>
                                        <td class="tw-py-4 tw-pr-4 tw-w-1/4 tw-text-right">
                                            <mh-core-lib-button
                                                [text]="isMobile ? ('commons.see' | translate) : ('commons.see_more' | translate)"
                                                [isSecondary]="true"
                                                [width]="'tw-w-fit'"
                                                [height]="34"
                                                [customClass]="'!tw-shadow-none'"
                                                [textClass]="'tw-font-normal'"
                                                [isDisabled]="!hotel.available"
                                                [mhTooltip]="hotel.available ? '' : 'interchain-dashboard.no_recommentaion_tooltip' | translate"
                                                [isDownloading]="generatingPdf() && selectedHotel() === hotel"
                                                [loaderClass]="'tw-flex tw-items-center tw-justify-center tw-w-[48px]'"
                                                (clicked)="handlePdfReport(hotel)">
                                            </mh-core-lib-button>
                                        </td>
                                    </tr>
                                }
                            } @else {
                                <tr>
                                    <td colspan="3" class="tw-text-center tw-text-gray-400 tw-text-base tw-italic tw-pb-3">
                                        {{ 'interchain-dashboard.widget_no_data' | translate }}
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        }
    } @else {
        <div class="tw-flex tw-justify-center tw-items-center tw-h-full tw-min-h-[8rem]">
            <mh-core-lib-loader-wrapper class="tw-text-4xl" [loading]="true" [type]="'spinner'"></mh-core-lib-loader-wrapper>
        </div>
    }
</div>
